// source: asset-mgmt/assetManagement.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var asset_util_pb = require('../asset/util_pb.js');
goog.object.extend(proto, asset_util_pb);
var asset_managedNode_pb = require('../asset/managedNode_pb.js');
goog.object.extend(proto, asset_managedNode_pb);
var vnf_vnf_pb = require('../vnf/vnf_pb.js');
goog.object.extend(proto, vnf_vnf_pb);
goog.exportSymbol('proto.asset.Asset', null, global);
goog.exportSymbol('proto.asset.AssetColumns', null, global);
goog.exportSymbol('proto.asset.AssetNode', null, global);
goog.exportSymbol('proto.asset.AssetNodeListResponse', null, global);
goog.exportSymbol('proto.asset.GetListAssetNodeRequest', null, global);
goog.exportSymbol('proto.asset.UploadListAssetRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.Asset.repeatedFields_, null);
};
goog.inherits(proto.asset.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Asset.displayName = 'proto.asset.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.AssetColumns = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.AssetColumns.repeatedFields_, null);
};
goog.inherits(proto.asset.AssetColumns, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.AssetColumns.displayName = 'proto.asset.AssetColumns';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.AssetNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.AssetNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.AssetNode.displayName = 'proto.asset.AssetNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.GetListAssetNodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.GetListAssetNodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.GetListAssetNodeRequest.displayName = 'proto.asset.GetListAssetNodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.UploadListAssetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.UploadListAssetRequest.repeatedFields_, null);
};
goog.inherits(proto.asset.UploadListAssetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.UploadListAssetRequest.displayName = 'proto.asset.UploadListAssetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.AssetNodeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.AssetNodeListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.AssetNodeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.AssetNodeListResponse.displayName = 'proto.asset.AssetNodeListResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.Asset.repeatedFields_ = [99];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
assetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
hostname: jspb.Message.getFieldWithDefault(msg, 2, ""),
assetType: jspb.Message.getFieldWithDefault(msg, 3, ""),
modelName: jspb.Message.getFieldWithDefault(msg, 4, ""),
serialNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
vendorName: jspb.Message.getFieldWithDefault(msg, 6, ""),
username: jspb.Message.getFieldWithDefault(msg, 7, ""),
department: jspb.Message.getFieldWithDefault(msg, 8, ""),
vpnAccount: jspb.Message.getFieldWithDefault(msg, 9, ""),
extraFieldListList: (f = jspb.Message.getRepeatedField(msg, 99)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Asset}
 */
proto.asset.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Asset;
  return proto.asset.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Asset}
 */
proto.asset.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setVpnAccount(value);
      break;
    case 99:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtraFieldList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHostname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSerialNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVendorName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVpnAccount();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExtraFieldListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      99,
      f
    );
  }
};


/**
 * optional string asset_id = 1;
 * @return {string}
 */
proto.asset.Asset.prototype.getAssetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setAssetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string hostname = 2;
 * @return {string}
 */
proto.asset.Asset.prototype.getHostname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setHostname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string asset_type = 3;
 * @return {string}
 */
proto.asset.Asset.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model_name = 4;
 * @return {string}
 */
proto.asset.Asset.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string serial_no = 5;
 * @return {string}
 */
proto.asset.Asset.prototype.getSerialNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setSerialNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string vendor_name = 6;
 * @return {string}
 */
proto.asset.Asset.prototype.getVendorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setVendorName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string username = 7;
 * @return {string}
 */
proto.asset.Asset.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string department = 8;
 * @return {string}
 */
proto.asset.Asset.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string vpn_account = 9;
 * @return {string}
 */
proto.asset.Asset.prototype.getVpnAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setVpnAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string extra_field_list = 99;
 * @return {!Array<string>}
 */
proto.asset.Asset.prototype.getExtraFieldListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 99));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.setExtraFieldListList = function(value) {
  return jspb.Message.setField(this, 99, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.addExtraFieldList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 99, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.Asset} returns this
 */
proto.asset.Asset.prototype.clearExtraFieldListList = function() {
  return this.setExtraFieldListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.AssetColumns.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.AssetColumns.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.AssetColumns.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.AssetColumns} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetColumns.toObject = function(includeInstance, msg) {
  var f, obj = {
columnNameListList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.AssetColumns}
 */
proto.asset.AssetColumns.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.AssetColumns;
  return proto.asset.AssetColumns.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.AssetColumns} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.AssetColumns}
 */
proto.asset.AssetColumns.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumnNameList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.AssetColumns.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.AssetColumns.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.AssetColumns} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetColumns.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnNameListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string column_name_list = 1;
 * @return {!Array<string>}
 */
proto.asset.AssetColumns.prototype.getColumnNameListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.asset.AssetColumns} returns this
 */
proto.asset.AssetColumns.prototype.setColumnNameListList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.asset.AssetColumns} returns this
 */
proto.asset.AssetColumns.prototype.addColumnNameList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.AssetColumns} returns this
 */
proto.asset.AssetColumns.prototype.clearColumnNameListList = function() {
  return this.setColumnNameListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.AssetNode.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.AssetNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.AssetNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetNode.toObject = function(includeInstance, msg) {
  var f, obj = {
asset: (f = msg.getAsset()) && proto.asset.Asset.toObject(includeInstance, f),
managedNode: (f = msg.getManagedNode()) && asset_managedNode_pb.ManagedNode.toObject(includeInstance, f),
userInfo: (f = msg.getUserInfo()) && vnf_vnf_pb.UserInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.AssetNode}
 */
proto.asset.AssetNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.AssetNode;
  return proto.asset.AssetNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.AssetNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.AssetNode}
 */
proto.asset.AssetNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.Asset;
      reader.readMessage(value,proto.asset.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 2:
      var value = new asset_managedNode_pb.ManagedNode;
      reader.readMessage(value,asset_managedNode_pb.ManagedNode.deserializeBinaryFromReader);
      msg.setManagedNode(value);
      break;
    case 3:
      var value = new vnf_vnf_pb.UserInfo;
      reader.readMessage(value,vnf_vnf_pb.UserInfo.deserializeBinaryFromReader);
      msg.setUserInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.AssetNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.AssetNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.AssetNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.Asset.serializeBinaryToWriter
    );
  }
  f = message.getManagedNode();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      asset_managedNode_pb.ManagedNode.serializeBinaryToWriter
    );
  }
  f = message.getUserInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      vnf_vnf_pb.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional Asset asset = 1;
 * @return {?proto.asset.Asset}
 */
proto.asset.AssetNode.prototype.getAsset = function() {
  return /** @type{?proto.asset.Asset} */ (
    jspb.Message.getWrapperField(this, proto.asset.Asset, 1));
};


/**
 * @param {?proto.asset.Asset|undefined} value
 * @return {!proto.asset.AssetNode} returns this
*/
proto.asset.AssetNode.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.AssetNode} returns this
 */
proto.asset.AssetNode.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.AssetNode.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ManagedNode managed_node = 2;
 * @return {?proto.asset.ManagedNode}
 */
proto.asset.AssetNode.prototype.getManagedNode = function() {
  return /** @type{?proto.asset.ManagedNode} */ (
    jspb.Message.getWrapperField(this, asset_managedNode_pb.ManagedNode, 2));
};


/**
 * @param {?proto.asset.ManagedNode|undefined} value
 * @return {!proto.asset.AssetNode} returns this
*/
proto.asset.AssetNode.prototype.setManagedNode = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.AssetNode} returns this
 */
proto.asset.AssetNode.prototype.clearManagedNode = function() {
  return this.setManagedNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.AssetNode.prototype.hasManagedNode = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional vnf.UserInfo user_info = 3;
 * @return {?proto.vnf.UserInfo}
 */
proto.asset.AssetNode.prototype.getUserInfo = function() {
  return /** @type{?proto.vnf.UserInfo} */ (
    jspb.Message.getWrapperField(this, vnf_vnf_pb.UserInfo, 3));
};


/**
 * @param {?proto.vnf.UserInfo|undefined} value
 * @return {!proto.asset.AssetNode} returns this
*/
proto.asset.AssetNode.prototype.setUserInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.AssetNode} returns this
 */
proto.asset.AssetNode.prototype.clearUserInfo = function() {
  return this.setUserInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.AssetNode.prototype.hasUserInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.GetListAssetNodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.GetListAssetNodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.GetListAssetNodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListAssetNodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.RequestPagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.GetListAssetNodeRequest}
 */
proto.asset.GetListAssetNodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.GetListAssetNodeRequest;
  return proto.asset.GetListAssetNodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.GetListAssetNodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.GetListAssetNodeRequest}
 */
proto.asset.GetListAssetNodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.RequestPagination;
      reader.readMessage(value,asset_util_pb.RequestPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.GetListAssetNodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.GetListAssetNodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.GetListAssetNodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListAssetNodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.RequestPagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional RequestPagination pagination = 1;
 * @return {?proto.asset.RequestPagination}
 */
proto.asset.GetListAssetNodeRequest.prototype.getPagination = function() {
  return /** @type{?proto.asset.RequestPagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.RequestPagination, 1));
};


/**
 * @param {?proto.asset.RequestPagination|undefined} value
 * @return {!proto.asset.GetListAssetNodeRequest} returns this
*/
proto.asset.GetListAssetNodeRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.GetListAssetNodeRequest} returns this
 */
proto.asset.GetListAssetNodeRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.GetListAssetNodeRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.UploadListAssetRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.UploadListAssetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.UploadListAssetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.UploadListAssetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.UploadListAssetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
assetListList: jspb.Message.toObjectList(msg.getAssetListList(),
    proto.asset.Asset.toObject, includeInstance),
columns: (f = msg.getColumns()) && proto.asset.AssetColumns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.UploadListAssetRequest}
 */
proto.asset.UploadListAssetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.UploadListAssetRequest;
  return proto.asset.UploadListAssetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.UploadListAssetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.UploadListAssetRequest}
 */
proto.asset.UploadListAssetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.Asset;
      reader.readMessage(value,proto.asset.Asset.deserializeBinaryFromReader);
      msg.addAssetList(value);
      break;
    case 2:
      var value = new proto.asset.AssetColumns;
      reader.readMessage(value,proto.asset.AssetColumns.deserializeBinaryFromReader);
      msg.setColumns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.UploadListAssetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.UploadListAssetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.UploadListAssetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.UploadListAssetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.asset.Asset.serializeBinaryToWriter
    );
  }
  f = message.getColumns();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.asset.AssetColumns.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Asset asset_list = 1;
 * @return {!Array<!proto.asset.Asset>}
 */
proto.asset.UploadListAssetRequest.prototype.getAssetListList = function() {
  return /** @type{!Array<!proto.asset.Asset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Asset, 1));
};


/**
 * @param {!Array<!proto.asset.Asset>} value
 * @return {!proto.asset.UploadListAssetRequest} returns this
*/
proto.asset.UploadListAssetRequest.prototype.setAssetListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.asset.Asset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Asset}
 */
proto.asset.UploadListAssetRequest.prototype.addAssetList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.asset.Asset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.UploadListAssetRequest} returns this
 */
proto.asset.UploadListAssetRequest.prototype.clearAssetListList = function() {
  return this.setAssetListList([]);
};


/**
 * optional AssetColumns columns = 2;
 * @return {?proto.asset.AssetColumns}
 */
proto.asset.UploadListAssetRequest.prototype.getColumns = function() {
  return /** @type{?proto.asset.AssetColumns} */ (
    jspb.Message.getWrapperField(this, proto.asset.AssetColumns, 2));
};


/**
 * @param {?proto.asset.AssetColumns|undefined} value
 * @return {!proto.asset.UploadListAssetRequest} returns this
*/
proto.asset.UploadListAssetRequest.prototype.setColumns = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.UploadListAssetRequest} returns this
 */
proto.asset.UploadListAssetRequest.prototype.clearColumns = function() {
  return this.setColumns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.UploadListAssetRequest.prototype.hasColumns = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.AssetNodeListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.AssetNodeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.AssetNodeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.AssetNodeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetNodeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
assetNodeListList: jspb.Message.toObjectList(msg.getAssetNodeListList(),
    proto.asset.AssetNode.toObject, includeInstance),
columns: (f = msg.getColumns()) && proto.asset.AssetColumns.toObject(includeInstance, f),
lastUploadedTimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.AssetNodeListResponse}
 */
proto.asset.AssetNodeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.AssetNodeListResponse;
  return proto.asset.AssetNodeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.AssetNodeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.AssetNodeListResponse}
 */
proto.asset.AssetNodeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.AssetNode;
      reader.readMessage(value,proto.asset.AssetNode.deserializeBinaryFromReader);
      msg.addAssetNodeList(value);
      break;
    case 3:
      var value = new proto.asset.AssetColumns;
      reader.readMessage(value,proto.asset.AssetColumns.deserializeBinaryFromReader);
      msg.setColumns(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastUploadedTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.AssetNodeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.AssetNodeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.AssetNodeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.AssetNodeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getAssetNodeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.AssetNode.serializeBinaryToWriter
    );
  }
  f = message.getColumns();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.asset.AssetColumns.serializeBinaryToWriter
    );
  }
  f = message.getLastUploadedTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.AssetNodeListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.AssetNodeListResponse} returns this
*/
proto.asset.AssetNodeListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.AssetNodeListResponse} returns this
 */
proto.asset.AssetNodeListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.AssetNodeListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AssetNode asset_node_list = 2;
 * @return {!Array<!proto.asset.AssetNode>}
 */
proto.asset.AssetNodeListResponse.prototype.getAssetNodeListList = function() {
  return /** @type{!Array<!proto.asset.AssetNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.AssetNode, 2));
};


/**
 * @param {!Array<!proto.asset.AssetNode>} value
 * @return {!proto.asset.AssetNodeListResponse} returns this
*/
proto.asset.AssetNodeListResponse.prototype.setAssetNodeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.AssetNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.AssetNode}
 */
proto.asset.AssetNodeListResponse.prototype.addAssetNodeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.AssetNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.AssetNodeListResponse} returns this
 */
proto.asset.AssetNodeListResponse.prototype.clearAssetNodeListList = function() {
  return this.setAssetNodeListList([]);
};


/**
 * optional AssetColumns columns = 3;
 * @return {?proto.asset.AssetColumns}
 */
proto.asset.AssetNodeListResponse.prototype.getColumns = function() {
  return /** @type{?proto.asset.AssetColumns} */ (
    jspb.Message.getWrapperField(this, proto.asset.AssetColumns, 3));
};


/**
 * @param {?proto.asset.AssetColumns|undefined} value
 * @return {!proto.asset.AssetNodeListResponse} returns this
*/
proto.asset.AssetNodeListResponse.prototype.setColumns = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.AssetNodeListResponse} returns this
 */
proto.asset.AssetNodeListResponse.prototype.clearColumns = function() {
  return this.setColumns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.AssetNodeListResponse.prototype.hasColumns = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 last_uploaded_timestamp = 4;
 * @return {number}
 */
proto.asset.AssetNodeListResponse.prototype.getLastUploadedTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.AssetNodeListResponse} returns this
 */
proto.asset.AssetNodeListResponse.prototype.setLastUploadedTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.asset);
